export default __webpack_public_path__ + "static/media/bakery-bread.9286b711.webp";